// extracted by mini-css-extract-plugin
var _1 = "action-button--bMOhf";
var _2 = "delete-action--RSC1q";
var _3 = "saved-reports-container--tT8Q3";
var _4 = "table-wrapper--drFwt";
export { _1 as "action-button", _2 as "delete-action", _3 as "saved-reports-container", _4 as "table-wrapper" }
